import React, { SyntheticEvent, useCallback, useMemo } from 'react';
import { OptionsObject } from 'components';
import { Criterion } from 'queries';

export const useCheckBoxToCriterion = (
  criterion: Criterion,
  onChange: (c: Criterion) => any,
  options: OptionsObject[],
): [
  any[] | (string | number)[],
  (e: React.SyntheticEvent<HTMLInputElement>) => any,
] => {
  const values = useMemo(() => {
    if (!criterion?.allowList?.length) {
      return [];
    }
    return criterion.allowList as string[] | number[];
  }, [criterion]);

  const _onChange = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      const value = e.currentTarget.value;
      const checked = e.currentTarget.checked;
      const allowList = [...values];
      if (checked && !allowList.includes(value)) {
        allowList.push(value);
      } else if (!checked) {
        const index = allowList.findIndex((val) => val.toString() === value);
        if (index === -1) {
          return;
        }
        allowList.splice(index, 1);
      }

      if (!allowList.length) {
        onChange({ ...criterion, allowList: null });
        return;
      }

      onChange({ ...criterion, allowList });
    },
    [onChange, criterion, options],
  );

  return [values, _onChange];
};
